export default "__VITE_ASSET__Dj6Foc_i__"